module.exports = __webpack_public_path__ + "img/out-img4.af2b2a53.png";